import React from 'react'
import classNames from 'classnames'
import { Placeholder } from '@/atoms/Placeholder'
import { useThemeContext } from '@/contexts/ThemeContext'

export const BannerPlaceholder = () => {
  const { isDarkMode } = useThemeContext()
  return (
    <div className="@container">
      <div
        className="relative mb-2 hidden w-full overflow-hidden rounded-xl bg-gray-200 lg:block"
        style={{ paddingTop: `${(334 / 2000) * 100}%` }}
      >
        <Placeholder
          placeholderClassName={classNames(isDarkMode ? 'bg-core-gray-900' : 'bg-core-gray-200')}
          className={'absolute inset-0 rounded-lg bg-gray-500'}
        />
      </div>

      <div
        className="relative mb-2 hidden w-full overflow-hidden rounded-xl bg-gray-200 md:block lg:hidden"
        style={{ paddingTop: `${(300 / 1200) * 100}%` }}
      >
        <Placeholder className={'absolute inset-0 rounded-lg bg-gray-500'} />
      </div>

      <div
        className="relative mb-2 w-full overflow-hidden rounded-lg bg-gray-200 md:hidden"
        style={{ paddingTop: `${(286 / 856) * 100}%` }}
      >
        <Placeholder className={'absolute inset-0 rounded-lg bg-gray-500'} />
      </div>
    </div>
  )
}
